import {
    POPULATE_FIRMWARE_PACKAGES,
    POPULATE_GEOFENCE_PACKAGES,
} from "../types";

export const binaryPackageReducer = (state, action) => {
  switch (action.type) {
    case POPULATE_FIRMWARE_PACKAGES:
      return {
        ...state,
        firmwarePackages: action.payload,
      };
    case POPULATE_GEOFENCE_PACKAGES:
      return {
        ...state,
        geofencePackages: action.payload,
      };
    default:
      return state;
  }
};
